import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MentorshipSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-[#FAF9F6]" data-testid="mentorship-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-amber-700 mb-6">
              Growth & Opportunity
            </p>
            
            <div className="flex items-start gap-4 mb-8">
              <h2 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight leading-tight font-serif">
                Mentorship That Moves People Forward
              </h2>
              <button 
                onClick={() => navigate('/mentoring')}
                className="mt-2 text-amber-600 hover:text-amber-700 transition-colors"
              >
                <ArrowRight className="w-8 h-8" />
              </button>
            </div>
            
            <div className="space-y-6 text-lg text-slate-600 font-light leading-relaxed">
              <p>
                We are committed to helping people grow forward. Our mentorship efforts focus on 
                building confidence, teaching real-world skills, and creating access to new 
                opportunities. We believe that with the right guidance, people don't just 
                survive—they grow.
              </p>
              
              <p>
                To operate at a high level and expand our impact, we align with leading technology 
                platforms. Our ecosystem is supported through tools and partnerships connected to 
                Google, Amazon, Salesforce, Microsoft, and T-Mobile.
              </p>
              
              <p>
                These relationships allow us to scale, operate efficiently, and reach more 
                people—turning good intentions into measurable results.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <img
              src="https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=800&q=80"
              alt="Military family reunion"
              className="w-full h-auto rounded-lg shadow-xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MentorshipSection;
